module.exports = __webpack_public_path__ + "static/media/wanchain.4be93072.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/img/hackathon/wanchain.png
// module id = 451
// module chunks = 0